import { createSlotRecipe } from './runtime.js';

const cardConfig = {"name":"card","slots":["root","media","header","body","footer","actions","linkOverlay","title","description"],"defaultVariants":{"ratio":"16/9","size":"md","variant":"outlined"},"variantMap":{"ratio":["1/1","16/9","4/3"],"size":["lg","md","sm","xl"],"variant":["elevated","outlined","subtle"]}}

export const card = /* @__PURE__ */ createSlotRecipe(cardConfig)